document.addEventListener('DOMContentLoaded', function () {
  const configurator = document.querySelector('.module-rotoclear-single-configurator');
  const accessory = configurator.querySelector('.rotoclear-configurator__accessory');
  const findAllQuestionGroups = function (selector = '.content-rotoclear-question-group,.rotoclear-configurator__question-group__question') {
    const questionGroups = configurator.querySelectorAll(selector);
    questionGroups.forEach(function (group) {
      addCollapseEvents(group);
      const groupId = group.getAttribute('data-question-group-id');
      updateGroupClasses(group, groupId);
    });
  };
  const addCollapseAccessoryEvents = function () {
    const accessoryHeadline = accessory.querySelector('.rotoclear-configurator__accessory__group_headline');
    const accessoryToggleButton = accessory.querySelector('.rotoclear-single-configurator__toggle-button');
    if (accessoryToggleButton) {
      accessoryToggleButton.addEventListener('click', function () {
        handleAccessoryToggle();
      });
    }
    if (accessoryHeadline) {
      accessoryHeadline.addEventListener('click', function () {
        handleAccessoryToggle();
      });
    }
  };

  const addCollapseEvents = function (element) {
    const elementHeadline = element.querySelector('.content-rotoclear-question-group__headline');
    const elementToggleButton = element.querySelector('.toggle-button');
    if (elementToggleButton) {
      if (!elementToggleButton.hasAttribute('data-listener-added')) {
        elementToggleButton.addEventListener('click', function () {
          handleGroupToggle(element);
        });
        elementToggleButton.setAttribute('data-listener-added', 'true');
      }
    }
    if (elementHeadline) {
      if (!elementHeadline.hasAttribute('data-listener-added')) {
        elementHeadline.addEventListener('click', function () {
          handleGroupToggle(element);
        });
        elementHeadline.setAttribute('data-listener-added', 'true');
      }
    }
  };

  const handleGroupToggle = function (element) {
    const groupId = element.getAttribute('data-question-group-id');
    if (!groupId) {
      console.error('No data-question-group-id found on the element.');
      return;
    }
    // Get state of the group
    const isExpanded = element.getAttribute('data-expanded') === 'true';
    element.setAttribute('data-expanded', !isExpanded);
    updateGroupClasses(element, groupId);
  };
  const updateGroupClasses = function (element, groupId) {
    // If we are not on mobile, get the state of the desktop group
    const isExpanded = isMobileScreenWidth() ? element.getAttribute('data-expanded') === 'true' : configurator.querySelector('.content-rotoclear-question-group[data-question-group-id="' + groupId + '"]').getAttribute('data-expanded') === 'true';
    updateButtonLabel(element, isExpanded);
    // Check if the element is a rotoclear-configurator__question-group__question 
    const isMobileGroup = element.classList.contains('rotoclear-configurator__question-group__question');
    let questions = configurator.querySelectorAll('.content-rotoclear-question[data-question-group-id="' + groupId + '"]:not(.rotoclear-configurator__question-group__question)');
    if (isMobileGroup) {
      questions = element.querySelectorAll('.content-rotoclear-question');
      // Look for all questions with that selector
    }
    // Toggle the state
    showTransition(questions, isExpanded);
  }

  const handleAccessoryToggle = function (
  ) {

    // Get state of the group
    const isExpanded = accessory.getAttribute('data-expanded') === 'true';
    accessory.setAttribute('data-expanded', !isExpanded);
    updateButtonLabel(accessory, !isExpanded);

    // Look for all questions with that group id
    const accessories = accessory.querySelectorAll('.content-rotoclear-product');
    // Toggle the state
    showTransition(accessories, !isExpanded);
  };

  const updateQuestionState = function (questionId, groupId) {
    const question = configurator.querySelector('.content-rotoclear-question[data-question-id="' + questionId + '"]');
    const group = configurator.querySelector('.content-rotoclear-question-group[data-question-group-id="' + groupId + '"]');
    if (!question || !group) {
      console.error('Question or group not found for IDs:', questionId, groupId);
      return;
    }
    const isExpanded = group.getAttribute('data-expanded') === 'true';
    showTransition([question], isExpanded);
  };

  const updateProductState = function (productId) {
    const product = configurator.querySelector('.content-rotoclear-product[data-product-id="' + productId + '"]');
    if (!product) {
      console.error('Product not found for ID:', productId);
      return;
    }
    const isExpanded = accessory.getAttribute('data-expanded') === 'true';
    showTransition([product], isExpanded);
  };

  const showTransition = function (elements, isExpanded) {
    elements.forEach(function (element) {
      element.classList.toggle('hidden', !isExpanded);
    });
  };
  const updateButtonLabel = function (element, isExpanded) {
    const buttons = element.querySelectorAll('.toggle-button');
    buttons.forEach(function (button) {
      const data = button.dataset;
      button.dataset.expanded = isExpanded;
      button.textContent = isExpanded ? data.labelClose : data.labelOpen;
    });
  };

  if (configurator) {
    configurator.addEventListener('configuratorInitialized', function () {
      findAllQuestionGroups();
      if (configurator.dataset.alwaysShowAccessory === 'false') {
        addCollapseAccessoryEvents();
      }
    });
    configurator.addEventListener('questionAdded', function (event) {
      findAllQuestionGroups('.rotoclear-configurator__question-group__question[data-question-group-id="' + event.detail.groupId + '"]');
      updateQuestionState(event.detail.questionId, event.detail.groupId);
    });
    if (configurator.dataset.alwaysShowAccessory === 'false') {
      configurator.addEventListener('productAdded', function (event) {
        updateProductState(event.detail.productId);
      });
    }
    findAllQuestionGroups();
    if (configurator.dataset.alwaysShowAccessory === 'false') {
      addCollapseAccessoryEvents();
    }
  }
});
